import React, { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames/bind";
// eslint-disable-next-line import/no-cycle
import { Modal } from "../Modal";
import { IframeResizer } from "../../utils/iframeResizer";
// eslint-disable-next-line import/no-cycle
import { Button } from "../Button";
import { Icon } from "../Icons";
import * as styles from "./WeddingModalForm.module.scss";

const cx = classNames.bind(styles);

const WeddingModalForm = ({ config, image, alt }) => {
	const initValue = config.type === "iframe";
	const [isOpen, setIsOpen] = useState(initValue);

	const loadIframeResize = () => {
		if (config.type === "modal") {
			setIsOpen(true);
		}

		setTimeout(() => {
			IframeResizer(window);
		}, 50);
	};

	let renderedComponent = null;

	if (image && alt && config.type === "modal") {
		renderedComponent = (
			<>
				<div className={cx(styles.modalContainer)}>
					<Button
						type="button"
						buttonType={null}
						onClick={loadIframeResize}
						className={cx(styles.modalImage)}
						defaultStyle={false}>
						<span className={cx(styles.modalFormButton, styles.image)}>
							<Icon name="gallery" />
						</span>
						<img src={image} alt={alt} />
					</Button>
				</div>

				<Modal
					contentLabel="content details"
					container="lg"
					isOpen={isOpen}
					onClose={() => {
						setIsOpen(false);
					}}>
					<Modal.Content>
						{config.type === "iframe" && isOpen && loadIframeResize()}
						<iframe
							className="fa-iframe"
							src={config.iframeUrl}
							frameBorder="0"
							height="0"
							width="100%"
							title={config?.title}
						/>
					</Modal.Content>
				</Modal>
			</>
		);
	} else if (config.type === "modal") {
		renderedComponent = (
			<>
				<Button
					type="button"
					buttonType={null}
					onClick={loadIframeResize}
					className={cx(styles.modalFormButton)}
					defaultStyle={false}>
					<Icon name="gallery" />
				</Button>

				<Modal
					contentLabel="content details"
					container="lg"
					isOpen={isOpen}
					onClose={() => {
						setIsOpen(false);
					}}>
					<Modal.Content>
						{config.type === "iframe" && isOpen && loadIframeResize()}
						<iframe
							className="fa-iframe"
							src={config.iframeUrl}
							frameBorder="0"
							height="0"
							width="100%"
							title={config?.title}
						/>
					</Modal.Content>
				</Modal>
			</>
		);
	} else if (config.type === "full" || config.type === "iframe") {
		renderedComponent = (
			<>
				{isOpen && loadIframeResize()}
				<iframe
					className="fa-iframe"
					src={config.iframeUrl}
					frameBorder="0"
					height="0"
					width="100%"
					title={config?.title}
				/>
			</>
		);
	}

	return renderedComponent;
};

WeddingModalForm.propTypes = {
	config: PropTypes.shape({
		iframeUrl: PropTypes.string,
		title: PropTypes.string,
		type: PropTypes.string,
	}).isRequired,
	image: PropTypes.string,
	alt: PropTypes.string,
};

export default WeddingModalForm;
export { WeddingModalForm };
